export default "__VITE_ASSET__AM1$Ygdq__"